const MYSHOPIFY_DOMAIN_PATTERN =
  /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.myshopify\.com$/;
const SHOPIFY_PUBLIC_API_KEY_PATTERN = /^[a-f0-9]{32}$/i;

export function normalizeAuthenticatedShopDomain(
  shopDomain: string | null | undefined
): string | null {
  const normalized = shopDomain?.trim().toLowerCase() || "";
  return MYSHOPIFY_DOMAIN_PATTERN.test(normalized) ? normalized : null;
}

export function normalizeShopifyPublicApiKey(
  apiKey: string | null | undefined
): string | null {
  const normalized = apiKey?.trim() || "";
  return SHOPIFY_PUBLIC_API_KEY_PATTERN.test(normalized) ? normalized : null;
}

export function configuredShopifyPublicApiKey(
  root: Pick<Document, "querySelector"> = document
): string | null {
  const meta = root.querySelector<HTMLMetaElement>('meta[name="shopify-api-key"]');
  return normalizeShopifyPublicApiKey(meta?.content);
}

export function buildProductConfiguratorThemeEditorUrl(
  authenticatedShopDomain: string | null | undefined,
  configuredApiKey: string | null | undefined
): string | null {
  const shopDomain = normalizeAuthenticatedShopDomain(authenticatedShopDomain);
  const apiKey = normalizeShopifyPublicApiKey(configuredApiKey);
  if (!shopDomain || !apiKey) return null;

  return (
    `https://${shopDomain}/admin/themes/current/editor` +
    `?template=product&addAppBlockId=${apiKey}/product-configurator&target=newAppsSection`
  );
}
